<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="padding-top: 120px; text-align: center;">Mad Larry! Psycho Tuesday! A horror movie in a pill!</p>
<p style="text-indent: 00em; padding-top: 15px; text-align: center;">---</p>
<p style="text-indent: 00em; padding-top: 15px; text-align: center;">’When you’re wounded and left on Afghanistan’s plains…</p>
<p style=" text-align: center;">Jest roll to your rifle and blow out your brains</p>
<p style=" text-align: center;">An’ go to your Gawd like a soldier.’</p><br/>
<p style=" text-align: right;">–Rudyard Kipling, The Young British Soldier</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?00cc8e45